import { ChevronRight, LayoutGrid, Notebook } from "tabler-icons-react";
import routeNames from "../../routes/routeNames";
export const jobSeekerData = [
  {
    icon: LayoutGrid,
    label: "Dashboard",
    path: routeNames.jobSeeker.dashboard,
  },
  {
    icon: Notebook,
    label: "My profile",
    path: routeNames.jobSeeker.myProfile,
  },
  {
    label: "News Feed",
    path: routeNames.jobSeeker.connections,
  },
  {
    label: "Search Job",
    path: routeNames.jobSeeker.searchJob,
  },
  {
    label: "Saerch People",
    path: routeNames.jobSeeker.searchPeople,
  },
  {
    label: "Search Company",
    path: routeNames.jobSeeker.searchCompany,
  },
  {
    label: "Job Applications",
    path: routeNames.jobSeeker.jobapplications,
  },
  // {
  //   icon: LayoutGrid,
  //   label: "News Feed",
  //   path: routeNames.jobSeeker.homeFeed,
  // },
  // {
  //   icon: BuildingStore,
  //   label: "Analytics",
  //   // path: routeNames.admin.userRoles,
  // },
  
  {
    icon: Notebook,
    label: "My Timeline",
    path: routeNames.jobSeeker.myposts,
  },
  {
    icon: Notebook,
    label: "Messages",
    path: routeNames.jobSeeker.messages,
  },
  {
    icon: Notebook,
    label: "Settings",
    path: routeNames.jobSeeker.settings,
  },
];
